import { BackednResponse } from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { IBriefDeliverableResponse } from "@shared/lib/types/briefInfluencerV2";
import { makeBriefDeliverablesQueryKey } from "../constants";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";

export function useGetBriefDeliverables(briefId: string) {
  const { data, isLoading, isError, error, isFetching } = useQuery<
    BackednResponse<IBriefDeliverableResponse[]>
  >({
    queryKey: makeBriefDeliverablesQueryKey(briefId),
    queryFn: () => BriefService.getBriefDeliverables(briefId),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    deliverables: data?.data,
    isFetching: isLoading,
    isError,
    isReFetching: isFetching,
  };
}
